export default function TrashIcon() {
    return (
    <svg width="21" height="20" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
<g id="Trash Icon">
<rect id="Rectangle 7" x="2.84375" y="3.07117" width="15.8125" height="2.0708" stroke="#FF6B6B"/>
<path id="Rectangle 5" d="M6.99219 2C6.99219 1.17157 7.66376 0.5 8.49219 0.5H13.0068C13.8353 0.5 14.5068 1.17157 14.5068 2V2.93566H6.99219V2Z" stroke="#FF6B6B"/>
<g id="Group 2">
<path id="Vector 19" d="M7.625 7.04492V17.5669" stroke="#FF6B6B"/>
<path id="Vector 20" d="M10.75 7.04492V17.5669" stroke="#FF6B6B"/>
<path id="Vector 21" d="M13.875 7.04492V17.5669" stroke="#FF6B6B"/>
</g>
<rect id="Rectangle 6" x="4.28027" y="5.12402" width="12.9072" height="14.376" stroke="#FF6B6B"/>
</g>
</svg>
    )
}
